import PivotConfigController from './pivot-config-controller';

const PivotConfigComponent: angular.IComponentOptions = {
  controller: PivotConfigController,
  controllerAs: 'ctrl',
  bindings: {
    height: '<',
    columns: '<',
    introHtml: '<?',
    hideIntro: '<?',
    quadrantMap: '<',
    onItemContextTriggered: '&?',
    onFilterChange: '&',
    onValueChange: '&',
    onColumnChange: '&',
    onRowChange: '&',
  },
  template: `
    <div class="pivot-config">
      <div class="columns" style="height: {{ctrl.getFieldListHeight()}}px">

        <div class="intro"
             ng-if="ctrl.introHtml && !ctrl.hideIntro"
             ng-bind-html="ctrl.getIntroHtml()"></div>

        <h4>Fields</h4>

        <!-- Draggable Column List Begins -->
        <draggable-item-list
          on-item-drag-start="ctrl.handleFieldListDragStart()"
          on-item-drag-end="ctrl.handleFieldListDragEnd()"
          selected-group-list-item="ctrl.selectedListItem"
          on-group-list-item-select="ctrl.handleListItemSelection($listId, $itemId)"
          items="ctrl.columnNames"
        />
        <!-- @Draggable Column List Ends -->

      </div>
      <div class="pivot-config-quadrants"
           ng-class="{'has-value': ctrl.quadrantHasValue(ctrl.quadrants), 'is-emphasized': ctrl.dragInProgress }">
        <div
          ng-repeat="quadrant in ctrl.quadrants"
          class="quadrant quadrant-{{quadrant.id}}">
          <div class="quadrant-title"><i class="{{quadrant.icon}} quadrant-icon"></i><span>{{quadrant.name}}</span></div>

          <!-- Drag Drop Quadrant Target Begins -->
          <droppable-target
            has-value="ctrl.quadrantHasValue(quadrant.id)"
            on-update="ctrl.handleQuadrantUpdate(quadrant.id, $value)">

            <!-- Selected Column List Begins -->
            <draggable-item-list
              context-id="quadrant.id"
              additional-text="{{ctrl.getAdditionalText(quadrant.id)}}"
              item-type="ctrl.getQuadrantDraggableType(quadrant.id)"
              list-type="ctrl.getQuadrantListType(quadrant.id)"
              selected-group-list-item="ctrl.selectedListItem"
              on-item-drag-end="ctrl.handleItemDragEnd($evt, quadrant.id, $itemId)"
              on-item-drag-start="ctrl.handleItemDragStart($evt, quadrant.id, $itemId)"
              on-group-list-item-select="ctrl.handleListItemSelection($listId, $itemId)"
              on-group-list-item-trigger="ctrl.handleListItemTrigger(quadrant.id, $listId, $itemId)"
              items="ctrl.quadrantValues(quadrant.id)"
            />
            <!-- @Selected Column List Ends -->

          </droppable-target>
          <!-- @Drag Drop Quadrant Target Ends -->

        </div>
      </div>
    </div>
  `,
};

export { PivotConfigComponent };
